// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gx-0";
export var actionModalContentContainer = "_gx-1";
export var createTagButton = "_gx-2";
export var footerContainer = "_gx-7";
export var fullWidthDivider = "_gx-3";
export var hasCreateTagButton = "_gx-4";
export var noCreateTagButton = "_gx-5";
export var tagsContainer = "_gx-6";
export var tagsModalContentContainer = "_gx-8";